/* Cart quantity badge on product cards, resynced on Horizon's cart:update event. */
(function () {
  'use strict';

  var lastCart = null;

  function apply(cart) {
    if (cart) lastCart = cart;
    var qtyByProduct = {};
    var items = (lastCart && lastCart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      qtyByProduct[it.product_id] = (qtyByProduct[it.product_id] || 0) + it.quantity;
    }

    var cards = document.querySelectorAll('.bq-card[data-product-id]');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var badge = card.querySelector('.bq-card__count');
      if (!badge) continue;
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      var n = qtyByProduct[pid] || 0;
      if (n > 0) {
        var label = n > 99 ? '99+' : String(n);
        if (badge.textContent !== label || badge.hidden) {
          badge.textContent = label;
          // Restart the bump on each quantity change.
          badge.classList.remove('bq-bump');
          void badge.offsetWidth;
          badge.classList.add('bq-bump');
        }
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
  }

  var refreshSeq = 0;
  function refresh() {
    // No card to badge: no request (article, FAQ, contact…).
    if (!document.querySelector('.bq-card[data-product-id]')) return;
    // Anti-race token: only the last refresh's response applies, since two
    // quick adds cross their fetches.
    var mine = ++refreshSeq;
    fetch('/cart.js', { headers: { accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart && mine === refreshSeq) apply(cart); })
      .catch(function () {});
  }

  // Coalesce the burst (finally, safety net, MutationObserver) into one request;
  // refreshSeq still guarantees last-write-wins.
  var refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshTimer = null; refresh(); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // shopify:cart:lines-update is optimistic: dispatched before POST /cart/add
  // commits, so an immediate refresh reads the stale cart.
  function onCartLinesUpdate(event) {
    // The promise rides on the event, not on `detail`: `event.detail` is
    // undefined and `event.promise` is the thenable Horizon awaits internally.
    var p = event && (event.promise || (event.detail && event.detail.promise));
    if (p && typeof p.finally === 'function') {
      p.finally(scheduleRefresh);
    } else {
      setTimeout(scheduleRefresh, 350);
    }
    // Safety net: some paths resolve the promise before the visible commit.
    setTimeout(scheduleRefresh, 1200);
  }
  document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);

  // Cards injected after the first scan (predictive search, morphs): reapply the
  // known cart without re-fetching, as soon as a .bq-card enters the DOM.
  var pending = false;
  function scheduleApply() {
    if (pending) return;
    pending = true;
    // Known state first, then server truth: every add triggers a morph (header
    // bubble), so this refresh covers a lost cart event.
    setTimeout(function () {
      pending = false;
      if (lastCart) apply();
      scheduleRefresh();
    }, 0);
  }
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('.bq-card') || n.querySelector('.bq-card'))) {
            scheduleApply();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.bqCardCart = { apply: function () { apply(); }, refresh: refresh };
})();
